import { Language, Voice } from '../types';

export const VOICES: Voice[] = [
	{ code: 'Aida', label: 'Аида', language: 'kz-KZ' },
	{ code: 'baya', label: 'Бая', language: 'ru-RU' },
	{ code: 'aidar', label: 'Айдар', language: 'ru-RU' },
	{ code: 'xenia', label: 'Ксения', language: 'ru-RU' },
	{ code: 'eugene', label: 'Евгений', language: 'ru-RU' },
];
export const LANGUAGES: Language[] = [
	{ code: 'kz-KZ', label: 'Қазақ' },
	{ code: 'ru-RU', label: 'Русский' },
];

export const API_URL = 'https://tts.dauys.com/tts/';
